import React, { useState } from "react";
import { TableBody, TableRow, TableCell, IconButton, Collapse, Box } from "@mui/material";
import { Renderer } from "../descriptors/common";
import { IfComp } from "@dvrt/react-tools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

type CollapsableTableRowProps = {
    id: any;
    collapseChild?: React.ReactNode;
    children: React.ReactNode;
};

const CollapsableTableRow = ({ id, collapseChild, children }: CollapsableTableRowProps) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow key={`${id}-top`} data-row-id={id} sx={{ "& > *": { borderBottom: "unset !important" } }}>
                <IfComp condition={!!collapseChild}>
                    <TableCell>
                        <IconButton onClick={() => setOpen((prev) => !prev)}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <FontAwesomeIcon
                                    size="xs"
                                    icon={open ? faChevronUp : faChevronDown}
                                    style={{ cursor: "pointer" }}
                                />
                            </Box>
                        </IconButton>
                    </TableCell>
                </IfComp>
                {children}
            </TableRow>
            <IfComp condition={!!collapseChild}>
                <TableRow key={`${id}-bottom`}>
                    <TableCell colSpan={6} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {collapseChild}
                        </Collapse>
                    </TableCell>
                </TableRow>
            </IfComp>
        </>
    );
};

type ListBodyProps = {
    data: any[];
    header: string[];
    renderers?: Record<string, Renderer>;
    collapseRenderer?: (row: any) => React.ReactNode;
};

export default class ListBody extends React.Component<ListBodyProps> {
    defaultRenderer(this: void, data: any) {
        return <span>{data}</span>;
    }

    getRendererObj = () => {
        const renderer: Record<string, Renderer> = {};
        this.props.header.forEach((key) => {
            renderer[key] = this.defaultRenderer;
            if (this.props.renderers !== undefined && this.props.renderers[key] !== undefined) {
                renderer[key] = this.props.renderers[key];
            }
        });
        return renderer;
    };

    render() {
        const data = [];
        const renderers = this.getRendererObj();
        this.props.data.forEach((row) => {
            const dataRow = [];
            const collapseCell = this.props.collapseRenderer?.(row);

            this.props.header.forEach((key) => {
                dataRow.push(<TableCell key={key}>{renderers[key](key in row ? row[key] : null, row)}</TableCell>);
            });

            data.push(
                <CollapsableTableRow key={row.id} id={row.id} collapseChild={collapseCell}>
                    {dataRow}
                </CollapsableTableRow>,
            );
        });

        return <TableBody>{data}</TableBody>;
    }
}
